export default __webpack_public_path__ + "default-pack.c97399.png";